import { render, staticRenderFns } from "./PrintingQueue.vue?vue&type=template&id=6944b2eb&scoped=true&"
import script from "./PrintingQueue.vue?vue&type=script&lang=js&"
export * from "./PrintingQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6944b2eb",
  null
  
)

export default component.exports